import { useState } from "react";
import useFormUtility from "../utilities/useFormUtility";
import Table from "../components/Table";
import RuleSection from "./RuleSection";
import MenuPage from "../components/MenuPage";
import MenuPageItemDiscard from "../components/MenuPageItemDiscard";
import MenuPageItemOk from "../components/MenuPageItemOk";
import useRateUtility from "../utilities/useRateUtility";

export default function OverrideSection({ data, sortOrder, onDiscard, onOk }) {
    
    const rateUtility = useRateUtility();

    var formUtility = useFormUtility(
        data
            ? {
                ...data,
                rateMode: data.rateMode.toString()
            }
            : {
                "id": null,
                "rateMode": "1",
                "rate": "",
                "baseRate": "",
                "sortOrder": sortOrder ?? 1,
                "rules": []
            }
    );

    const [selectedIndexRule, setSelectedIndexRule] = useState(-1);

    function handleOnOkRule(rule) {
        if (selectedIndexRule < 0 && selectedIndexRule !== -2)
            return;

        let rules = [...formUtility.data.rules];

        selectedIndexRule >= 0
            ? rules.splice(selectedIndexRule, 1, rule)
            : rules.push(rule);

        formUtility.handleChange([{ field: "rules", value: rules }]);
        setSelectedIndexRule(-1);
    }

    function handleOnRemoveRule(idx) {
        if (idx < 0)
            return;

        let rules = [...formUtility.data.rules];
        rules.splice(idx, 1);
        formUtility.handleChange([{ field: "rules", value: rules }]);
    }

    function handleOk() {
        let rate = (formUtility.data.rate ?? "").toString().trim() === "" ? 0 : formUtility.data.rate;
        let baseRate = formUtility.data.rateMode === "1" || (formUtility.data.baseRate ?? "").toString().trim() === "" ? 0 : formUtility.data.baseRate;

        var numberRate = Number(rate);
        if (isNaN(numberRate) || numberRate < 0)
            return formUtility.showNotification(2, "Invalid rate.");

        var numberBaseRate = Number(baseRate);
        if (isNaN(numberBaseRate) || numberBaseRate < 0)
            return formUtility.showNotification(2, "Invalid base rate.");

        if (!formUtility.data.sortOrder || formUtility.data.sortOrder.length < 1 || parseInt(formUtility.data.sortOrder) < 1)
            return formUtility.showNotification(2, "Invalid sort order.");

        if (formUtility.data.rules.length < 1)
            return formUtility.showNotification(2, "At least one rule is required.");
        
        var result = {
            ...formUtility.data,
            rateMode: parseInt(formUtility.data.rateMode),
            rate: numberRate,
            baseRate: numberBaseRate,
            sortOrder: parseInt(formUtility.data.sortOrder)
        };
        
        onOk(result);
    }

    return (
            <div className="override-section">
                {
                    selectedIndexRule >= 0 || selectedIndexRule === -2
                        ? <RuleSection
                            data={selectedIndexRule === -2 ? null : formUtility.data.rules[selectedIndexRule]}
                            onDiscard={onDiscard}
                            onOk={handleOnOkRule} />
                        :
                        <>
                            <MenuPage>
                                <MenuPageItemDiscard formUtility={formUtility} onClick={onDiscard} />
                                <MenuPageItemOk formUtility={formUtility} onClick={handleOk} />
                            </MenuPage>
                            <div className="form-group">
                                <label>Rate Mode</label>
                                <select
                                    name="rateMode"
                                    className="form-control"
                                    onChange={formUtility.handleChangeControl}>
                                    {
                                        rateUtility.rateModes.map(x =>
                                            <option value={x.value} selected={formUtility.data.rateMode === x.value.toString()}>{x.name}</option>
                                        )
                                    }
                                </select>
                                {formUtility.data.rateMode === "1" ? <p>Allows you to set a specific rate you want to charge for shipping.</p> : null}
                                {formUtility.data.rateMode === "2" ? <p>Allows you charge a percentage of the fulfillment value for shipping.</p> : null}
                                {formUtility.data.rateMode === "3" ? <p>Allows you charge a rate per item in the fulfillment for shipping.</p> : null}
                                {formUtility.data.rateMode === "4" ? <p>Allows you charge a rate per kilogram in the fulfillment for shipping.</p> : null}
                            </div>
                            <div className="form-group">
                                <label>Rate</label>
                                <input className="form-control" name="rate" type="text" value={formUtility.data.rate} onChange={formUtility.handleChangeControl} onKeyDown={formUtility.onKeyDownNumberOnly} />
                                {formUtility.data.rateMode === "1" ? <p>The rate for shipping.</p> : <p>The rate for calculations.</p>}
                            </div>
                            {
                                formUtility.data.rateMode !== "1"
                                    ?
                                    <div className="form-group">
                                        <label>Base Rate</label>
                                        <input className="form-control" name="baseRate" type="text" value={formUtility.data.baseRate} onChange={formUtility.handleChangeControl} onKeyDown={formUtility.onKeyDownNumberOnly} />
                                        <p>The base rate added to the calculated rate.</p>
                                    </div>
                                    : null
                            }
                            <br />
                            <h2>Rules</h2>
                            <Table
                                formUtility={formUtility}
                                data={formUtility.data.rules}
                                mappings={
                                    [
                                        {
                                            header: "Type",
                                            field: "ruleType",
                                            dataType: "ruleType"
                                        },
                                        {
                                            header: "Condition",
                                            field: "condition",
                                            dataType: "condition"
                                        },
                                        {
                                            header: "Value",
                                            field: "value"
                                        },
                                        {
                                            header: "Or Group",
                                            field: "orGroup"
                                        }
                                    ]
                                }
                                onClickAdd={() => setSelectedIndexRule(-2)}
                                onClick={setSelectedIndexRule}
                                onRemove={handleOnRemoveRule}
                            />
                        </>
                }
            </div>
    );
}